import HTML from "../assets/icons/skill-icons--html.svg";
import ReactIcon from "../assets/icons/skill-icons--react-dark.svg";
import Sass from "../assets/icons/skill-icons--sass.svg";
import Javascript from "../assets/icons/skill-icons--javascript.svg";
import CSS from "../assets/icons/skill-icons--css.svg";
import Node from "../assets/icons/skill-icons--nodejs-dark.svg";
import Git from "../assets/icons/skill-icons--git.svg";
import Express from "../assets/icons/skill-icons--expressjs-light.svg";
import Knex from "../assets/icons/devicon--knexjs-wordmark.svg";
import MySQL from "../assets/icons/logos--mysql.svg";
import TypeScriptIcon from "../assets/icons/skill-icons--typescript.svg";
import Tailwind from "../assets/icons/skill-icons--tailwindcss-dark.svg";
import GoLang from "../assets/icons/skill-icons--golang.svg";
import Python from "../assets/icons/logos--python.svg";

export const techStack = [
  {
    title: "HTML",
    link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
    icon: HTML,
  },
  {
    title: "CSS",
    link: "https://www.w3schools.com/css/css_intro.asp",
    icon: CSS,
  },
  { title: "React", link: "https://react.dev/", icon: ReactIcon },
  { title: "Sass", link: "https://sass-lang.com/", icon: Sass },

  {
    title: "JavaScript",
    link: "https://www.javascript.com",
    icon: Javascript,
  },
  { title: "Node.js", link: "https://nodejs.org", icon: Node },
  { title: "Git", link: "https://git-scm.com", icon: Git },
  { title: "Express.js", link: "https://expressjs.com", icon: Express },
  { title: "Knex.js", link: "http://knexjs.org", icon: Knex },
  { title: "MySQL", link: "https://www.mysql.com", icon: MySQL },
];

export const learning = [
  {
    title: "TypeScript",
    link: "https://www.typescriptlang.org/",
    icon: TypeScriptIcon,
  },
  { title: "Tailwind", link: "https://tailwindcss.com/", icon: Tailwind },
  { title: "Go", link: "https://go.dev/", icon: GoLang },
  {
    title: "Python",
    link: "https://python.org/",
    icon: Python,
  },
];
